"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigmaContainer = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const sigma_1 = require("sigma");
const graphology_1 = tslib_1.__importDefault(require("graphology"));
const context_1 = require("./context");
const lodash_1 = require("lodash");
const SigmaContainer = ({ graphOptions, id, className, style, initialSettings, children, }) => {
    const containerRef = react_1.useRef(null);
    const props = { className: `react-sigma-v2 ${className ? className : ""}`, id, style };
    const [sigma, setSigma] = react_1.useState(null);
    const settings = react_1.useRef();
    if (!lodash_1.isEqual(settings.current, initialSettings))
        settings.current = initialSettings;
    const graph = react_1.useRef();
    if (!lodash_1.isEqual(graph.current, graphOptions))
        graph.current = graphOptions;
    react_1.useEffect(() => {
        let instance = null;
        if (containerRef.current !== null) {
            instance = new sigma_1.Sigma(new graphology_1.default(graph.current), containerRef.current, settings.current);
            setSigma(instance);
        }
        return () => {
            setSigma(() => {
                if (instance) {
                    instance.kill();
                }
                return null;
            });
        };
    }, [containerRef, graph, settings]);
    const context = react_1.useMemo(() => (sigma ? { sigma } : null), [sigma]);
    const contents = context !== null ? react_1.default.createElement(context_1.SigmaProvider, { value: context }, children) : null;
    return (react_1.default.createElement("div", Object.assign({}, props),
        react_1.default.createElement("div", { className: "sigma-container", ref: containerRef }),
        contents));
};
exports.SigmaContainer = SigmaContainer;
//# sourceMappingURL=SigmaContainer.js.map